//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import DateString from '@models/DateString';
import PinterestBoardId from '@models/PinterestBoardId';
import PostableId from '@models/PostableId';
import { Normalized } from '@utils/normalize';
import PinterestBoardSectionId from '@models/PinterestBoardSectionId';
import { IScheduledPin } from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';

export const PINTEREST_SCHEDULE_TASK_NAME = 'publish:schedule_pinterest_item';
export const SCHEDULE_PIN_FETCH_LIMIT = 80;

export interface IPinterestScheduleState {
  scheduledPins: NormalizedScheduledPins;

  startDate: DateString;
  filterBoardId?: PinterestBoardId;
  filterBoardSectionId?: PinterestBoardSectionId;

  // The start date that we last fetched new posts for
  lastFetchedStartDate: DateString;

  errors: {
    fetchScheduledPinsError?: string;
  };
  flags: {
    isFetchingScheduledPins: boolean;
    isInitialScheduleDataLoaded: boolean;
    isDeletingPin: boolean;
  };
}

export type NormalizedScheduledPins = Normalized<IScheduledPin, PostableId>;

export interface ITimelinePinGroup {
  date: DateString;
  items: IScheduledPin[];
}
